import './style.scss';
import { defaults } from 'lodash-es';
import React, { useEffect } from 'react';
import { InitialUrlSearchParams } from '../../../../utils/environment';
import { useWindowSize } from '../../react-hooks';

// ? [REVISIT] `copy` is an ecom jargon
const DEFAULT_COPY = {
  preHeading: 'App Exclusive',
  heading: 'Shop Our Mobile App To Get First Dibs!',
  desktopSubHeading:
    'This limited-edition item is going to sell fast! Scan this code from your phone to download today!',
  mobileSubHeading: 'This limited-edition item is going to sell fast! Visit our app today!',
  // ? [REVISIT] bad names
  button1Copy: 'Download the App',
  button2Copy: 'I Have the App - Take Me There',
} as const;

const DEFAULT_OPTIONS = {
  enableDocumentScrollLock: true,
};

type Props = {
  copy?: Partial<typeof DEFAULT_COPY>;
  className?: string;
  options?: Partial<typeof DEFAULT_OPTIONS>;
};

// ? [REVISIT] use modal component?
export const AppExlusiveOverlay: React.FC<Props> = ({ copy, className = '', options }) => {
  const { enableDocumentScrollLock } = defaults(options, DEFAULT_OPTIONS);

  useEffect(() => {
    if (enableDocumentScrollLock) {
      window.scrollTo({
        top: 0,
      });
      setDocumentScrollLock(true);
    }
    return () => {
      if (enableDocumentScrollLock) setDocumentScrollLock(false);
    };
  }, [enableDocumentScrollLock]);

  const { desktopSubHeading, heading, mobileSubHeading, preHeading, button1Copy, button2Copy } = defaults(
    copy,
    DEFAULT_COPY
  );

  const appUrlScheme = 'com.aloyoga.shop';
  const appUrl = window.location.href.replace(/^https/, appUrlScheme);

  const windowSize = useWindowSize();
  const navOffset = computeNavOffset();
  return (
    <div
      className={`AppExlusiveOverlay ${className}`}
      style={navOffset ? { height: windowSize.height - navOffset } : undefined}
    >
      <div className="text-container text-center">
        <h4 className="h4 uppercase">{preHeading}</h4>
        <h1 className="h1 uppercase">{heading}</h1>
        <p className="large-p center download__large-p desktop-only">{desktopSubHeading}</p>
        <p className="large-p center download__large-p mobile-only">{mobileSubHeading}</p>
        <div className="qr-section">
          <img
            src={'https://qr.alo.software/qr?text=' + encodeURIComponent(window.location.href)}
            alt="Point your cell phone camera at the screen to read this QR code"
          />
        </div>
        <div className="button-section">
          <a className="button" href="/pages/app">
            {button1Copy}
          </a>
          <a className="button button-app" href={appUrl}>
            {button2Copy}
          </a>
        </div>
      </div>
    </div>
  );
};

const computeNavOffset = () => {
  const navNode = document.querySelector('nav');
  if (!navNode) return null;
  const { height, top } = navNode.getBoundingClientRect();
  const navOffset = top + height;
  return navOffset;
};

// ? [REVISIT] from https://markus.oberlehner.net/blog/simple-solution-to-prevent-body-scrolling-on-ios/
// ? -- 3rd party solution or simpler way of doing it
const bodyElement = document.body;
let scrollPosition = 0;
const setDocumentScrollLock = (hideOverFlow: boolean) => {
  if (hideOverFlow) {
    scrollPosition = window.pageYOffset;
    bodyElement.style.overflow = 'hidden';
    bodyElement.style.position = 'fixed';
    bodyElement.style.top = `-${scrollPosition}px`;
    bodyElement.style.width = '100%';
  } else {
    bodyElement.style.removeProperty('overflow');
    bodyElement.style.removeProperty('position');
    bodyElement.style.removeProperty('top');
    bodyElement.style.removeProperty('width');
    window.scrollTo(0, scrollPosition);
  }
};

export const calculateIfIsApp = (userAgent: string) => {
  const secret = 'FollowApp';
  const isFakedApp =
    window.Shopify.theme?.role === 'unpublished' && InitialUrlSearchParams.get('pretendAppMode') === 'true';
  return isFakedApp || userAgent.indexOf(secret) !== -1;
};
